import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
  Table,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

//redux
import {
  getPesoCompetencias,
  deletePesoCompetencia,
  editPesoCompetencia,
  savePesoCompetencia,
  resetPesoCompetencias,
} from "../../../redux/evaluacion_desempenio/pesoCompetencia/actions";
import {
  getCompetenciesDesc,
  resetCompetenciesDesc,
} from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import Compencia from "../../../components/evaluacion_desempenio/Compencia";
import toastr from "toastr";
import {
  getClassification,
  saveClassification,
  editClassification,
  deleteClassification,
} from "../../../redux/Classification/actions";
import {
  getPeriodicity,
  resetPeriodicity,
  resetPeriodicityByOrg,
} from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import { getOrgs } from "../../../redux/organization/actions";

const schema = Yup.object().shape({
  descripcion: Yup.string().ensure().required("**Campo requerido"),
  peso: Yup.number()
    .integer("El número no puede tener decimales.")
    .required("**Campo requerido")
    .min(0, "El número no puedo ser menor a 0"),
});

const PesoCompetencia = (props) => {
  const [show, setShow] = useState(true);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [totalPesos, setTotalPesos] = useState(0);
  const [_clasificacion, setClasificacion] = useState("");
  const [_empresa, setEmpresa] = useState("");
  const [_periodo, setPeriodo] = useState("");
  const [_anio, setAnio] = useState("");

  const dispatch = useDispatch();
  const fecha = new Date();
  var n = fecha.getFullYear();

  const pesoCompetenciaStore = useSelector((store) => store.pesoCompetencia);
  const {
    loaderCompetenciesDesc,
    saveLoaderCompetencieDesc,
    competenciesDesc,
    competenciesDescFaild,
    formcompetencieDescFaild,
  } = useSelector((store) => store.competenciesDesc);

  const {
    loaderPesoCompetencia,
    pesoCompetencia,
    pesoCompetenciaFalla,
    saveLoaderPesoCompetencia,
    pesoCompetenciaFormError,
  } = pesoCompetenciaStore;

  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );

  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );

  const {
    loading: loadingPeriodicity,
    saveLoading: saveLoadingPeriodicity,
    periodicity,
    periodicityError,
    formError: formErrorPeriodicity,
    periodicitys,
    loadingPeriodicitys,
  } = useSelector((store) => store.periodicity);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const pages = Math.ceil(
    competenciesDesc ? competenciesDesc.count / limit : 0
  );

  const getAClassification = (filt = filter) =>
    dispatch(
      getClassification(
        {
          filter: filt,
        },
        2
      )
    );

  const _getCompetenciasDesc = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetenciesDesc({
        offset: offs,
        limit: lim,
        tipo_busqueda: "clasificacion_id",
        filter: filt,
      })
    );

  const _getPesoCompetencias = (
    offs = offset,
    lim = limit,
    filt = filter,
    period = _periodo
  ) =>
    dispatch(
      getPesoCompetencias({
        tipo_busqueda: "periodicidad_id",
        filter: period,
        tipo_busqueda_2: "clasificacion_id",
        filter_2: filt,
      })
    );

  useEffect(() => {
    setClasificacion("");
    setFilter("");
    dispatch(getOrgs(parseInt(2)));
    dispatch(resetCompetenciesDesc());
    dispatch(resetPesoCompetencias());
    getAClassification({});
    dispatch(resetPeriodicity());
    dispatch(resetPeriodicityByOrg());
    // _getPesoCompetencias();
    // _getCompetenciasDesc();
  }, []);

  useEffect(() => {
    if (pesoCompetencia && pesoCompetencia.count > 0) {
      var val = 0;
      pesoCompetencia.data.map((fac) => {
        val = val + parseInt(fac.peso);
      });
      setTotalPesos(val);
    } else {
      setTotalPesos(0);
    }
  }, [pesoCompetencia]);

  useEffect(() => {
    if (
      periodicitys &&
      periodicitys.length > 0 &&
      _periodo !== "" &&
      _clasificacion !== ""
    ) {
      // setPeriodo(periodicitys[periodicitys.length - 1].id);
      if (periodicitys.find((e) => e.anio === n)) {
        _getCompetenciasDesc(offset, limit, _clasificacion);
        _getPesoCompetencias(
          offset,
          limit,
          _clasificacion,
          periodicitys.find((e) => e.anio === n).id
        );
      } else {
        _getCompetenciasDesc(offset, limit, _clasificacion);
        _getPesoCompetencias(
          offset,
          limit,
          _clasificacion,
          periodicitys[periodicitys.length - 1].id
        );
      }
    } else {
      dispatch(resetCompetenciesDesc());
      dispatch(resetPesoCompetencias());
    }
  }, [periodicitys, _periodo, _clasificacion]);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0) {
      if (periodicitys.find((e) => e.anio === n)) {
        setPeriodo(periodicitys.find((e) => e.anio === n).id);
        setAnio(periodicitys.find((e) => e.anio === n).anio);
      } else {
        setPeriodo(periodicitys[periodicitys.length - 1].id);
        setAnio(periodicitys[periodicitys.length - 1].anio);
      }
    } else {
      setPeriodo("");
    }
  }, [periodicitys]);

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              PESO POR COMPETENCIA
            </h5>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col md="12">
            <Row>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingClasificacion ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          defaultValue=""
                          onChange={(e) => {
                            e.preventDefault();
                            setClasificacion(e.currentTarget.value);
                            setFilter(e.currentTarget.value);
                            if (_empresa !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(_empresa),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(e.currentTarget.value),
                                })
                              );
                            }
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            //  selected
                            //  disabled
                          >
                            Selecionar clasificación
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre ? item.nombre : ""}
                                  </option>
                                ))
                            : ""}
                        </Form.Control>
                      </Col>
                      {loadingClasificacion ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          defaultValue=""
                          disabled={loadingOrgs}
                          onChange={(e) => {
                            e.preventDefault();
                            setEmpresa(e.currentTarget.value);
                            if (_clasificacion !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(e.currentTarget.value),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(_clasificacion),
                                })
                              );
                            }
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Periodicidad
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      {!loadingPeriodicitys && (
                        <>
                          <Col sm={loadingPeriodicitys ? "10" : "12"}>
                            <Form.Control
                              as="select"
                              id="periodicidad"
                              name="periodicidad"
                              className="col rounded-pill"
                              defaultValue={
                                periodicitys &&
                                periodicitys.length > 0 &&
                                periodicitys.find((e) => e.anio === n)
                                  ? periodicitys.find((e) => e.anio === n).id
                                  : periodicitys && periodicitys.length > 0
                                  ? periodicitys[periodicitys.length - 1].id
                                  : ""
                              }
                              disabled={
                                loadingPeriodicitys ||
                                (periodicitys && periodicitys.length === 0)
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                setPeriodo(e.currentTarget.value);
                                setAnio(
                                  periodicitys.find(
                                    (e) =>
                                      e.id === parseInt(e.currentTarget.value)
                                  ).anio
                                );
                                _getCompetenciasDesc(
                                  offset,
                                  limit,
                                  _clasificacion
                                );
                                _getPesoCompetencias(
                                  offset,
                                  limit,
                                  _clasificacion,
                                  e.currentTarget.value
                                );
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar periodicidad
                              </option>
                              {periodicitys.length > 0 &&
                                periodicitys.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.list_frecuencia[0].nombre}
                                    {" - "}
                                    {moment(item.fecha_fin).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </option>
                                ))}
                            </Form.Control>
                          </Col>
                        </>
                      )}
                      {loadingPeriodicitys ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {/* <Col md="12">
            <Row>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingClasificacion ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          defaultValue=""
                          onChange={(e) => {
                            e.preventDefault();
                            setClasificacion(e.currentTarget.value);
                            setFilter(e.currentTarget.value);
                            _getCompetenciasDesc(
                              offset,
                              limit,
                              e.currentTarget.value
                            );
                            _getPesoCompetencias(
                              offset,
                              limit,
                              e.currentTarget.value
                            );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                          >
                            Selecionar clasificación
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre ? item.nombre : ""}
                                  </option>
                                ))
                            : ""}
                        </Form.Control>
                      </Col>
                      {loadingClasificacion ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col> */}
          {!!pesoCompetenciaFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {pesoCompetenciaFalla}
            </Alert>
          )}
          {/* {_periodo !== "" && (
            <Alert variant="info" className="mt-4 mb-1 mx-3">
              No hay periodicidades para esta empresa, clasificación
            </Alert>
          )} */}
          {loaderPesoCompetencia || loaderCompetenciesDesc ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : competenciesDesc &&
            competenciesDesc.data.length > 0 &&
            _periodo !== "" ? (
            <>
              <Card className="mt-2 border-0">
                <Card.Body className="px-1 px-sm-2">
                  {/* <CustomTable
                      columns={columns}
                      data={competenciesDesc.data}

                    /> */}
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Competencia</th>
                        <th>Clasificación</th>
                        <th>Peso</th>
                        <th>Rendimiento esperado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {competenciesDesc.data.map((item, index) => (
                        <Compencia
                          item={item}
                          index={index}
                          pesoCompetencia={pesoCompetencia}
                          totalPesos={totalPesos}
                          setTotalPesos={setTotalPesos}
                          period={_periodo}
                          isClosed={n !== _anio}
                        />
                      ))}
                    </tbody>
                  </Table>
                  {/* <p align="right">
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderPesoCompetencia}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderPesoCompetencia && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  </p> */}
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={competenciesDesc ? competenciesDesc.count : 0}
                pages={pages}
                pagFunc={_getCompetenciasDesc}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default PesoCompetencia;
